/** Auto text written to Individualized Feedback when Execution is flipped red. */
export const EXECUTION_FIX_PROMPT = "Tell me what you need to fix here";

export const FOLLOW_UP_AUTO_ADDED = {
  message: "Follow-Up Added Automatically",
  description: "Wardbord created a follow-up question from your evaluation.",
};

export const isBlankFeedback = (feedback) => !String(feedback ?? "").trim();

export const isOnlyExecutionFixPrompt = (feedback) =>
  String(feedback ?? "").trim() === EXECUTION_FIX_PROMPT;

/**
 * Next positive_feedback when Execution toggles, or undefined to leave unchanged.
 * value 0 = red/X (add prompt if empty); value 1 = blue/check (clear only exact prompt).
 * Clear uses "" — Grades.positive_feedback is string without allowNull, so null is ignored.
 */
export const nextFeedbackForExecution = (currentFeedback, executionValue) => {
  if (Number(executionValue) === 0) {
    return isBlankFeedback(currentFeedback) ? EXECUTION_FIX_PROMPT : undefined;
  }
  if (Number(executionValue) === 1) {
    return isOnlyExecutionFixPrompt(currentFeedback) ? "" : undefined;
  }
  return undefined;
};

/**
 * Mutates details like sacks→tackles autofill when part is assignment_executed.
 * @returns {boolean} true only when the follow-up prompt was newly auto-added
 */
export const applyExecutionFeedbackAutomation = (
  details,
  part,
  value,
  currentFeedback,
) => {
  if (part !== "assignment_executed") return false;
  const next = nextFeedbackForExecution(currentFeedback, value);
  if (next === undefined) return false;
  details.positive_feedback = next;
  return next === EXECUTION_FIX_PROMPT;
};
